<template>
  <el-tooltip
    effect="dark"
    content="Export file will contain not more than 5000 records"
    placement="top-start"
  >
    <template #default>
      <el-dropdown :disabled="dsb" @command="handleCommand">
        <el-button type="primary" size="small">
          Export
          <el-icon class="el-icon--right">
            <DownloadElementIcon />
          </el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="csv"> CSV </el-dropdown-item>
            <el-dropdown-item command="xlsx"> XLSX </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'ExportButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const handleCommand = (command: string) => {
      context.emit('click', command)
    }

    const dsb = computed(() => {
      return props.disabled
    })

    return { handleCommand, dsb }
  }
})
</script>
